import { proThemeClassName, useProThemeStore } from "@/stores/pro-theme";

export function useProPortalThemeClass(): "pro-dark" | "pro-light" | undefined {
  const theme = useProThemeStore((state) => state.theme);

  if (typeof document === "undefined") return undefined;
  return document.documentElement.dataset.appSurface === "pro"
    ? proThemeClassName(theme)
    : undefined;
}
